// src/app/local-auth.guard.ts
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { TeamService } from '../api/services/team.service';

export const authenticatedGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router = inject(Router);
    const teamService = inject(TeamService);

    return teamService.getTeams(1, 0).pipe(
        map(() => true),
        catchError(() => of(router.createUrlTree(['/login'], { queryParams: { redirectUrl: state.url } })))
    );
};
